import { render, staticRenderFns } from "./UserProtocol.vue?vue&type=template&id=b2c8a468&scoped=true"
import script from "./UserProtocol.vue?vue&type=script&lang=js"
export * from "./UserProtocol.vue?vue&type=script&lang=js"
import style0 from "./UserProtocol.vue?vue&type=style&index=0&id=b2c8a468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c8a468",
  null
  
)

export default component.exports